import React, { useCallback, useEffect, useState } from "react";
import { push } from "connected-react-router";
import { useSelector } from "react-redux";
import { Col, Badge, Modal } from "antd";
import { connect } from "react-redux";
import { useIntl } from "react-intl";

import colors from "../../../colors";
import { warn } from "../../../modules/messages";
import { isUser } from "../../../modules/session";
import CustomIcon from "../../app/generic/customIcon";
import { handleError } from "../../../modules/errorLogger";
import { checkHttpStatus, get } from "../../../modules/httpFunctions";

function Info({ push, onSetCountOfDocs }) {
  const intl = useIntl();
  const { user, authenticated } = useSelector((state) => state.session);

  const onlyUser = isUser(user?.role);
  const close = intl.formatMessage({
    id: "messages.close",
    defaultMessage: "Zavřít",
  });

  const getMessage = useCallback(
    (cnt) => {
      return intl.formatMessage(
        {
          id: "document.read.info",
          defaultMessage: "Máte dokumenty ke zpracování. {second}",
        },
        {
          cnt: cnt,
          second: onlyUser
            ? intl.formatMessage({
                id: "document.read.info.user",
                defaultMessage:
                  "Informujte prosím uživatele s rolí administrátor o této skutečnosti.",
              })
            : intl.formatMessage({
                id: "document.read.info.admin",
                defaultMessage:
                  "Pro zpracování přejděte do sekce dokumentu v levém menu.",
              }),
        }
      );
    },
    [intl, onlyUser]
  );

  const [count, setCount] = useState();
  const handleDocCheck = useCallback(
    (hide) => {
      get("document/status")
        .then((r) => {
          const cnt = checkHttpStatus(r) && r.data && r.data.toProcess;
          onSetCountOfDocs(cnt);
          setCount(cnt);
          !hide && cnt && warn(getMessage(cnt));
        })
        .catch((err) => {
          handleError(err);
        });
    },
    [getMessage, onSetCountOfDocs]
  );
  useEffect(() => {
    const timeout = setTimeout(() => authenticated && handleDocCheck(), 1000);
    const interval =
      authenticated &&
      setInterval(() => {
        handleDocCheck(true);
      }, 10000);
    return () => {
      interval && clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [authenticated, handleDocCheck]);

  const handleIconClick = useCallback(() => {
    if (count > 0) {
      onlyUser
        ? Modal.info({
            content: getMessage(count),
            okText: close,
          })
        : push("/documents");
    }
  }, [push, close, onlyUser, count, getMessage]);

  return authenticated && count > 0 ? (
    <Col className="notification-container">
      <Badge count={count} className="document-badge" offset={[4, -2]}>
        <CustomIcon
          fontSize={30}
          type="file-text"
          className="pointer"
          color={colors.RED}
          placement="bottom"
          onClick={handleIconClick}
          title={intl.formatMessage({
            id: "document.read",
            defaultMessage: "máte dokumenty ke zpracování",
          })}
        />
      </Badge>
    </Col>
  ) : (
    <></>
  );
}

export default connect(null, { push })(Info);
